import { useLanguage } from "../i18n/LanguageContext";

const Row = ({ hidden, items }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-10 font-serif text-xl italic tracking-wide text-[#F4EFE6]/40 sm:text-2xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-amber-500/60" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLanguage();
  const items = t("marquee");
  return (
    <div className="relative overflow-hidden border-y border-amber-500/15 bg-[#0B1D16] py-5" dir="ltr">
      <div className="marquee-track">
        <Row hidden={false} items={items} />
        <Row hidden={true} items={items} />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B1D16] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B1D16] to-transparent" />
    </div>
  );
};
